import { render, staticRenderFns } from "./QACard.vue?vue&type=template&id=38968fec&scoped=true&"
import script from "./QACard.vue?vue&type=script&lang=js&"
export * from "./QACard.vue?vue&type=script&lang=js&"
import style0 from "./QACard.vue?vue&type=style&index=0&id=38968fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38968fec",
  null
  
)

export default component.exports